/* Lettoria ODD LOT SALE — wallet offers engine (shared by the landing page + the odd-lot PDP section; no page deps).
 * The two automatic discounts ops set up (brief update 10-15, replaces "2 pcs −5% / 3+ −10%"):
 *   · WALLET WITH ANY BAG — each bag in odd-lot-bags unlocks $4 off one wallet in odd-lot-wallets, max 2 wallets/order
 *   · WALLET TRIO         — 3+ wallets in odd-lot-wallets → $7 off the order (once)
 * Shopify never stacks both on one wallet and applies the better one; the real saving is cart.total_discount, so the
 * engine never estimates a saved amount. Brief §5 progress messages:
 *   ≥1 bag, 0 wallets   → "Add a wallet for $4 off — from $8.95"     (offer = bag)
 *   2+ bags, 1 wallet   → "Add 1 more wallet for another $4 off"      (offer = bag)
 *   0 bags, 1–2 wallets → "Add {3−W} more wallet(s) to save $7"       (offer = trio)
 *   qualified           → "You're saving $X" (cart.total_discount)   (offer = none)
 * Data: <script type="application/json" data-ol-mw>{% render 'lettoria-odd-lot-sale-matching-wallets-json' %}</script>
 * on the page (auto-read below). Usage: OLOffers.tally(cart.items) → OLOffers.status(tally, cart, walletMin$). */
(function () {
  var BAG_OFF = 4, TRIO_OFF = 7, MAX_BAG_WALLETS = 2, TRIO_AT = 3;
  var B = {}, W = {};
  function money(n) { return '$' + Number(n).toFixed(2); }
  function init(json) {
    try { var j = typeof json === 'string' ? JSON.parse(json) : json; B = j.b || {}; W = {}; (j.w || []).forEach(function (h) { W[h] = true; }); } catch (e) {}
  }
  function kind(handle) { return W[handle] ? 'wallet' : (B[handle] || /-odd-lot-deal(-\d+)?$/.test(handle || '')) ? 'bag' : null; }
  // bags = Odd Lot non-wallet lines (bags with no matching wallet still count via the handle suffix)
  function tally(items) {
    var t = { bags: 0, wallets: 0, bagHandles: [], walletHandles: {} };
    (items || []).forEach(function (it) {
      var k = kind(it.handle);
      if (k === 'wallet') { t.wallets += it.quantity; t.walletHandles[it.handle] = true; }
      else if (k === 'bag') { t.bags += it.quantity; t.bagHandles.push(it.handle); }
    });
    return t;
  }
  function status(t, cart, walletMin) {
    var saved = (cart && cart.total_discount) || 0;
    var from = walletMin ? money(walletMin - BAG_OFF) : '';
    if (t.bags >= 1 && t.wallets === 0) return { offer: 'bag', text: 'Add a wallet for $' + BAG_OFF + ' off' + (from ? ' — from ' + from : '') };
    if (t.bags >= 2 && t.wallets === 1) return { offer: 'bag', text: 'Add 1 more wallet for another $' + BAG_OFF + ' off' };
    if (t.bags === 0 && t.wallets >= 1 && t.wallets < TRIO_AT) {
      var n = TRIO_AT - t.wallets;
      return { offer: 'trio', text: 'Add ' + n + ' more wallet' + (n > 1 ? 's' : '') + ' to save $' + TRIO_OFF };
    }
    if ((t.bags >= 1 && t.wallets >= 1) || t.wallets >= TRIO_AT) {
      return { offer: null, ok: true, text: saved > 0 ? "You're saving " + money(saved / 100) : '✓ Wallet deal unlocked' };
    }
    return { offer: 'any', text: 'Add a wallet for ' + (from || '$' + BAG_OFF + ' off') + ' with any bag' };
  }
  // wallets to suggest: same design as the bags in the cart first, then the given fallback list; never ones in the cart
  function suggest(t, fallback, max) {
    var out = [], seen = {};
    function push(h) { if (h && !seen[h] && !t.walletHandles[h]) { seen[h] = true; out.push(h); } }
    t.bagHandles.forEach(function (h) { (B[h] || []).forEach(push); });
    (fallback || []).forEach(push);
    return out.slice(0, max || 3);
  }
  function matching(bagHandle) { return (B[bagHandle] || []).slice(); }
  // is a wallet in this cart going to get the bag price (−$4)? true while a bag slot is still open
  function bagSlotOpen(t) { return t.bags >= 1 && t.wallets < Math.min(t.bags, MAX_BAG_WALLETS); }
  var el = document.querySelector('[data-ol-mw]');
  if (el) init(el.textContent);
  window.OLOffers = { BAG_OFF: BAG_OFF, TRIO_OFF: TRIO_OFF, init: init, kind: kind, tally: tally, status: status, suggest: suggest, matching: matching, bagSlotOpen: bagSlotOpen, money: money };
})();
